
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import filterProjectParts from "../components/filter-project-parts.vue";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
const employee = namespace("employee");
const serviceItem = namespace("service-item");
const parts = namespace("parts");
@Component({
  components: {
    filterProjectParts
  }
})
export default class CreateProjectPushMoney extends Vue {
  @employee.Mutation setFilterProjectPartsDialog;
  @employee.State filterProjectPartsDialog;
  @employee.Action createBusinessCommission;
  @employee.Action getBusinessCommissionConfig;
  @employee.Action updateBusinessCommission;
  @employee.Action getPartsCommissionPage;
  @employee.Action getServicesCommissionPage;
  @serviceItem.Action getServiceItemList;
  @parts.Action getPartsList;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  t = t;
  showCopySure = false;
  showCopySureExternal = false;
  //计算属性
  get breadData() {
    return this.getPushMoney === "parts"
      ? [
          { name: t("v210831.parts-commission"), path: "/employee/emplyee-push-money/push-money-set" },
          { name: this.myIsEdit ? t("v210831.edit-parts-commission") : t("v210831.new-parts-commission") }
        ]
      : [
          { name: t("v210831.project-commission"), path: "/employee/emplyee-push-money/push-money-set" },
          { name: this.myIsEdit ? t("v210831.edit-project-commission") : t("v210831.commission-for-new") }
        ];
  }
  returnForm = {
    revisitType: "1"
  };
  get isPatrs() {
    return this.getPushMoney === "parts"
      ? [
          { label: t("v210831.accrual-by-order"), value: "order" },
          { label: t("v210831.withdrawn-according-to"), value: "actual" },
          { label: t("v210831.withdrawn-by-gross"), value: "gross" }
        ]
      : [
          { label: t("v210831.accrual-by-order"), value: "order" },
          { label: t("v210831.withdrawn-according-to"), value: "actual" }
        ];
  }
  businessList = [];
  businessType = this.getBusinessType;
  createForm = {
    saleIntervalList: [],
    saleCommissionType: "none",
    saleCommissionAmountType: "order",
    serviceIntervalList: [],
    serviceCommissionType: "none",
    serviceCommissionAmountType: "order" // 提成金额类型
  };
  externalCreateForm = {
    saleIntervalList: [],
    saleCommissionType: "none",
    saleCommissionAmountType: "order",
    serviceIntervalList: [],
    serviceCommissionType: "none",
    serviceCommissionAmountType: "order" // 提成金额类型
  };
  get footerFlag() {
    return !this.filterProjectPartsDialog;
  }
  get getBusinessList() {
    return (
      this.tableData.map(item => {
        return {
          businessCode: item.serviceCode || item.partsCode || item.businessCode,
          businessName: item.serviceName || item.partsNameDesc || item.partsName || item.businessName,
          businessNumber: item.serviceNumber || item.partsNumber || item.businessNumber
        };
      }) || []
    );
  }
  get getBusinessType() {
    return this.getPushMoney === "parts" ? "parts" : "services";
  }
  newServiceItemList: any = [
    {
      commissionStartInterval: "",
      commissionEndInterval: "",
      commissionValue: ""
    }
  ];
  newPartsItemList: any = [
    {
      commissionStartInterval: "",
      commissionEndInterval: "",
      commissionValue: ""
    }
  ];
  externalNewServiceItemList: any = [
    {
      commissionStartInterval: "",
      commissionEndInterval: "",
      commissionValue: ""
    }
  ];
  externalNewPartsItemList: any = [
    {
      commissionStartInterval: "",
      commissionEndInterval: "",
      commissionValue: ""
    }
  ];
  tableData = [];
  checkedCities = [];
  chechedAll = false;
  multipleSelectionArr = [];
  isIndeterminate = false;
  getPushMoney: any = "project";
  get myIsEdit() {
    return this.$route.name === "editProjectPushMoney";
  }
  created() {
    this.getPushMoney = this.$route.query.type || this.$route.params.type;
    this.init();
  }

  async init() {
    const queryCode = this.$route.query.code as string;
    const queryType = this.$route.query.type;
    if (queryCode) {
      if (queryType === "services") {
        this.getServiceItemList({
          pageSize: 999,
          pageNum: 1,
          serviceCodeList: queryCode.split(",")
        }).then(data => {
          this.tableData = data.data?.list;
        });
      } else {
        this.getPartsList({
          pageSize: 999,
          pageNum: 1,
          partsCodeList: queryCode.split(",")
        }).then(data => {
          this.tableData = data.data?.list;
        });
      }
    }
    if (this.myIsEdit) {
      let params = {
        businessCode: this.$route.query.code,
        serviceCodes: "",
        partsCodes: "",
        businessType: this.getPushMoney === "parts" ? "parts" : "services",
        pageSize: "999"
      };
      let res;
      if ((this.$route.query.code as any).split(",").length === 1) {
        res = await this.getBusinessCommissionConfig(params);
        if (res.data?.arrivalCommission) {
          this.createForm = {
            ...res.data.arrivalCommission
          };
          this.newServiceItemList = [...this.$safeValue(res, "data.arrivalCommission.serviceIntervalList", [])];
          this.newPartsItemList = [...this.$safeValue(res, "data.arrivalCommission.saleIntervalList", [])];
        }
        if (res.data.externalCommission) {
          this.externalCreateForm = {
            ...res.data.externalCommission
          };
          if (res.data.externalCommission.serviceIntervalList) {
            this.externalNewServiceItemList = [...res.data.externalCommission.serviceIntervalList];
          }
          if (res.data.externalCommission.saleIntervalList) {
            this.externalNewPartsItemList = [...res.data.externalCommission.saleIntervalList];
          }
        }
      } else {
        if (this.getPushMoney === "parts") {
          params.partsCodes = (this.$route.query.code as any).split(",");
          await this.getPartsCommissionPage(params);
        } else if (this.getPushMoney === "services") {
          params.serviceCodes = (this.$route.query.code as any).split(",");
          await this.getServicesCommissionPage(params);
        }
      }
    }
  }
  async footerSure() {
    let param = {
      businessType: this.getBusinessType,
      businessList: this.getBusinessList,
      arrivalCommission: {
        ...this.createForm,
        saleIntervalList: this.newPartsItemList,
        serviceIntervalList: this.newServiceItemList
      },
      externalCommission: {
        ...this.externalCreateForm,
        saleIntervalList: this.externalNewPartsItemList,
        serviceIntervalList: this.externalNewServiceItemList
      }
    };
    if (!this.getBusinessList.length) {
      this.$message.warning(t("v210831.please-select-commission-project-parts"));
      return;
    }
    if (this.createForm.saleCommissionType !== "none") {
      if (!this.createForm.saleCommissionAmountType) {
        return this.$message.warning(t("v210831.please-select-the-nature-sell-type"));
      }
      let partsFlag = this.newPartsItemList.every(item => {
        return (
          Number(item.commissionEndInterval) > Number(item.commissionStartInterval) &&
          item.commissionValue &&
          Number(item.commissionValue) > 0 &&
          Number(item.commissionEndInterval) > 0 &&
          Number(item.commissionStartInterval) >= 0
        );
      });
      for (let i = 1; i < this.newPartsItemList.length; i++) {
        if (
          Number(this.newPartsItemList[i - 1].commissionEndInterval) >=
          Number(this.newPartsItemList[i].commissionStartInterval)
        ) {
          this.$message.warning(t("v210831.price-ranges-cannot-two-one"));
          return;
        }
      }
      for (let item of this.newPartsItemList) {
        let re = /^\d+$/;
        if (!re.test(item.commissionStartInterval) || !re.test(item.commissionEndInterval)) {
          this.$message.warning(t("v210831.only-positive-integers"));
          return;
        }
      }
      if (!partsFlag || !this.newPartsItemList.length) {
        this.$message.warning(t("v210831.unreasonable-setting-of-sell-section"));
        return;
      }
    }
    if (this.createForm.serviceCommissionType !== "none") {
      if (!this.createForm.serviceCommissionAmountType) {
        return this.$message.warning(t("v210831.please-select-the-nature-service-type"));
      }
      let serviceFlag = this.newServiceItemList.every(item => {
        return (
          Number(item.commissionEndInterval) > Number(item.commissionStartInterval) &&
          item.commissionValue &&
          Number(item.commissionValue) > 0 &&
          Number(item.commissionEndInterval) > 0 &&
          Number(item.commissionStartInterval) >= 0
        );
      });
      for (let i = 1; i < this.newServiceItemList.length; i++) {
        if (
          Number(this.newServiceItemList[i - 1].commissionEndInterval) >=
          Number(this.newServiceItemList[i].commissionStartInterval)
        ) {
          this.$message.warning(t("v210831.price-ranges-cannot-two-one-not-overlay"));
          return;
        }
      }
      for (let i = 0; i < this.newServiceItemList.length; i++) {
        let re = /^\d+$/;
        if (
          !re.test(this.newServiceItemList[i].commissionStartInterval) ||
          !re.test(this.newServiceItemList[i].commissionEndInterval)
        ) {
          this.$message.warning(t("v210831.only-positive-integers"));
          return;
        }
      }
      if (!serviceFlag || !this.newServiceItemList.length) {
        this.$message.warning(t("v210831.unreasonable-setting-of-not-rational"));
        return;
      }
    }
    if (this.externalCreateForm.saleCommissionType !== "none") {
      if (!this.externalCreateForm.saleCommissionAmountType) {
        return this.$message.warning(t("v210831.please-select-the-output-sell-type"));
      }
      let partsFlag = this.externalNewPartsItemList.every(item => {
        return (
          Number(item.commissionEndInterval) > Number(item.commissionStartInterval) &&
          item.commissionValue &&
          Number(item.commissionValue) > 0 &&
          Number(item.commissionEndInterval) > 0 &&
          Number(item.commissionStartInterval) >= 0
        );
      });
      for (let i = 1; i < this.externalNewPartsItemList.length; i++) {
        if (
          Number(this.externalNewPartsItemList[i - 1].commissionEndInterval) >=
          Number(this.externalNewPartsItemList[i].commissionStartInterval)
        ) {
          this.$message.warning(t("v210831.price-ranges-cannot-two-one-not-overlay"));
          return;
        }
      }
      for (let i = 0; i < this.externalNewPartsItemList.length; i++) {
        let re = /^[0-9]+$/;
        if (
          !re.test(this.externalNewPartsItemList[i].commissionStartInterval) ||
          !re.test(this.externalNewPartsItemList[i].commissionEndInterval)
        ) {
          this.$message.warning(t("v210831.only-positive-integers"));
          return;
        }
      }
      if (!partsFlag || !this.externalNewPartsItemList.length) {
        this.$message.warning(t("v210831.unreasonable-setting-of-sell-not"));
        return;
      }
    }
    if (this.externalCreateForm.serviceCommissionType !== "none") {
      if (!this.externalCreateForm.serviceCommissionAmountType) {
        return this.$message.warning(t("v210831.please-select-the-output-service-type"));
      }
      let serviceFlag = this.externalNewServiceItemList.every(item => {
        return (
          Number(item.commissionEndInterval) > Number(item.commissionStartInterval) &&
          item.commissionValue &&
          Number(item.commissionValue) > 0 &&
          Number(item.commissionEndInterval) > 0 &&
          Number(item.commissionStartInterval) >= 0
        );
      });
      for (let i = 1; i < this.externalNewServiceItemList.length; i++) {
        if (
          Number(this.externalNewServiceItemList[i - 1].commissionEndInterval) >=
          Number(this.externalNewServiceItemList[i].commissionStartInterval)
        ) {
          this.$message.warning(t("v210831.price-ranges-cannot-two-one-not-over"));
          return;
        }
      }
      for (let i = 0; i < this.externalNewServiceItemList.length; i++) {
        let re = /^[0-9]+$/;
        if (
          !re.test(this.externalNewServiceItemList[i].commissionStartInterval) ||
          !re.test(this.externalNewServiceItemList[i].commissionEndInterval)
        ) {
          this.$message.warning(t("v210831.only-positive-integers"));
          return;
        }
      }
      if (!serviceFlag || !this.externalNewServiceItemList.length) {
        this.$message.warning(t("v210831.unreasonable-setting-of-not-rational"));
        return;
      }
    }
    if (this.myIsEdit) {
      this.updatePushMoney(param);
    } else {
      this.creattPushMoney(param);
    }
  }
  async creattPushMoney(param) {
    let res = await this.createBusinessCommission(param);
    if (res.data) {
      this.$message.success(t("v210831.the-newly-added"));
      this.$router.push("/employee/emplyee-push-money/push-money-set");
    } else {
      this.$message.warning(t("v210831.failed-to-add"));
    }
  }
  async updatePushMoney(param) {
    let res = await this.createBusinessCommission(param);
    if (res.data) {
      this.$message.success(t("v210831.commission-setting-modified"));
      this.$router.push("/employee/emplyee-push-money/push-money-set");
    } else {
      this.$message.warning(t("v210831.failed-to-modify"));
    }
  }
  checkChange(val) {
    let tableRef = this.$refs.multipleTable as any;
    tableRef.toggleAllSelection();
    this.checkedCities = val ? this.tableData : [];
    this.isIndeterminate = false;
  }
  getCreateArr(arr) {
    let type = this.getPushMoney === "parts" ? "partsCode" : "serviceCode";
    let newArr = this.tableData.concat(arr);
    const result = [];
    const obj = {};
    for (let i = 0; i < newArr.length; i++) {
      if (!obj[newArr[i][type]]) {
        result.push(newArr[i]);
        obj[newArr[i][type]] = true;
      }
    }
    this.tableData = result;
  }
  remove(row) {
    let type = this.getPushMoney === "parts" ? "partsCode" : "serviceCode";
    this.tableData = this.tableData.filter(item => {
      return item[type] !== row[type];
    });
  }
  definitionNewTestItem: any = {
    remark: "",
    checkItemCode: "",
    sort: ""
  };
  handleInsertRow(index) {
    this.newServiceItemList.splice(index + 1, 0, Object.assign({}, this.definitionNewTestItem));
  }
  handleDeleteRow(index) {
    if (this.newServiceItemList.length > 1) {
      this.newServiceItemList.splice(index, 1);
    } else {
      this.$message.warning(t("v210831.please-set-at-one-push-money"));
    }
  }
  handleInsertRowExternal(index) {
    this.externalNewServiceItemList.splice(index + 1, 0, Object.assign({}, this.definitionNewTestItem));
  }
  handleDeleteRowExternal(index) {
    if (this.externalNewServiceItemList.length > 1) {
      this.externalNewServiceItemList.splice(index, 1);
    } else {
      this.$message.warning(t("v210831.please-set-at-one-push-money"));
    }
  }
  handleInsertRowParts(index) {
    this.newPartsItemList.splice(index + 1, 0, Object.assign({}, this.definitionNewTestItem));
  }
  handleInsertRowPartsExternal(index) {
    this.externalNewPartsItemList.splice(index + 1, 0, Object.assign({}, this.definitionNewTestItem));
  }
  handleDeleteRowParts(index) {
    if (this.newPartsItemList.length > 1) {
      this.newPartsItemList.splice(index, 1);
    } else {
      this.$message.warning(t("v210831.please-set-at-one-push-money"));
    }
  }
  handleDeleteRowPartsExternal(index) {
    if (this.externalNewPartsItemList.length > 1) {
      this.externalNewPartsItemList.splice(index, 1);
    } else {
      this.$message.warning(t("v210831.please-set-at-one-push-money"));
    }
  }
  showDialog() {
    // 触发了
    this.setFilterProjectPartsDialog(true);
  }
  openCopySure() {
    this.showCopySure = true;
  }
  openCopySureExternal() {
    this.showCopySureExternal = true;
  }
  handleCopySure() {
    this.externalCreateForm = {
      ...this.createForm
    };
    this.externalNewServiceItemList = this.newServiceItemList.map(item => {
      return { ...item };
    });
    this.externalNewPartsItemList = this.newPartsItemList.map(item => {
      return { ...item };
    });
    this.showCopySure = false;
  }
  handleCopySureExternal() {
    this.createForm = {
      ...this.externalCreateForm
    };
    this.newServiceItemList = this.externalNewServiceItemList.map(item => {
      return { ...item };
    });
    this.newPartsItemList = this.externalNewPartsItemList.map(item => {
      return { ...item };
    });
    this.showCopySureExternal = false;
  }
  changeHeder(type) {
    if (type === "order") {
      return addCurrencyUnit(t("v210831.order-amount-range"), false, true);
    } else if (type === "actual") {
      return addCurrencyUnit(t("v210831.paid-in-amount-section"), false, true);
    } else if (type === "gross") {
      return addCurrencyUnit(t("v210831.gross-profit-amount"), false, true);
    } else {
      return addCurrencyUnit(t("v210831.order-amount-range"), false, true);
    }
  }
  // //
}
